import { useState } from "react";

const services = [
  {
    num: "01",
    icon: "ri-building-4-line",
    title: "Foundation Systems",
    description:
      "We build the core infrastructure your business runs on—ensuring every lead, customer, and workflow is captured and organized. Without a solid foundation, every system above it is unstable.",
    includes: [
      "CRM architecture & setup",
      "Pipeline design & structuring",
      "Lead capture systems",
      "Data structuring & organization",
    ],
    img: "https://public.readdy.ai/ai/img_res/86d14bf21fe3164ddf8a5454dae31de3.jpg",
  },
  {
    num: "02",
    icon: "ri-git-branch-line",
    title: "Workflow Structuring",
    description:
      "We eliminate manual work and inconsistencies by designing automated workflows that handle follow-ups, scheduling, and task management—so your team focuses on what matters.",
    includes: [
      "Automated follow-up sequences",
      "Smart lead routing",
      "Appointment & scheduling systems",
      "Internal workflow automation",
    ],
    img: "https://readdy.ai/api/search-image?query=automation%20workflow%20diagram%20dark%20background%20with%20connected%20nodes%20and%20pathways%2C%20representing%20business%20process%20automation%20and%20intelligent%20routing%20systems%2C%20dark%20minimal%20tech%20aesthetic%20with%20green%20accent%20lines&width=800&height=500&seq=svc002&orientation=landscape",
  },
  {
    num: "03",
    icon: "ri-rocket-2-line",
    title: "Scale Infrastructure",
    description:
      "We layer advanced AI systems into your operations to enable scalable growth without increasing complexity. Built for businesses ready to move from managed growth to compounding growth.",
    includes: [
      "Custom AI agents",
      "Reporting & analytics dashboards",
      "Performance tracking systems",
      "Continuous optimization loops",
    ],
    img: "https://readdy.ai/api/search-image?query=advanced%20AI%20system%20infrastructure%20visualization%20dark%20background%2C%20machine%20learning%20data%20flow%20diagrams%20with%20neural%20pathways%2C%20dark%20sophisticated%20tech%20aesthetic%20with%20emerald%20green%20glowing%20data%20streams%2C%20scale%20and%20growth%20visualization&width=800&height=500&seq=svc003&orientation=landscape",
  },
];

export default function ServiceDetailCards() {
  const [expanded, setExpanded] = useState<number | null>(0);

  return (
    <section className="w-full bg-[#09090B] py-24 px-6 border-t border-white/5">
      <div className="max-w-7xl mx-auto">
        <div className="space-y-5">
          {services.map((svc, idx) => (
            <div
              key={svc.num}
              className={`border rounded-2xl overflow-hidden transition-all duration-500 ${
                expanded === idx
                  ? "border-[#4ADE80]/30 bg-[#0F1510]"
                  : "border-white/8 bg-[#141418] hover:border-white/15"
              }`}
            >
              {/* Header */}
              <button
                onClick={() => setExpanded(expanded === idx ? null : idx)}
                className="w-full flex items-center justify-between px-10 py-7 cursor-pointer"
              >
                <div className="flex items-center gap-5">
                  <span className="text-sm font-mono text-white/25">{svc.num}</span>
                  <div className={`w-9 h-9 flex items-center justify-center ${expanded === idx ? "text-[#4ADE80]" : "text-white/50"}`}>
                    <i className={`${svc.icon} text-xl`} />
                  </div>
                  <h3
                    className={`text-xl md:text-2xl font-bold transition-colors ${expanded === idx ? "text-white" : "text-white/70"}`}
                    style={{ fontFamily: "'Space Grotesk', sans-serif" }}
                  >
                    {svc.title}
                  </h3>
                </div>
                <div className={`w-8 h-8 flex items-center justify-center text-white/40 transition-transform duration-300 ${expanded === idx ? "rotate-45" : ""}`}>
                  <i className="ri-add-line text-xl" />
                </div>
              </button>

              {/* Expanded content */}
              {expanded === idx && (
                <div className="px-10 pb-10 grid grid-cols-1 md:grid-cols-2 gap-10">
                  {/* Left */}
                  <div>
                    <p className="text-base text-white/55 leading-relaxed mb-8">
                      {svc.description}
                    </p>

                    <div>
                      <p className="text-xs font-semibold uppercase tracking-widest text-[#4ADE80]/70 mb-4">
                        What&apos;s Included
                      </p>
                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                        {svc.includes.map((item) => (
                          <div key={item} className="flex items-start gap-2">
                            <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                              <i className="ri-check-line text-[#4ADE80] text-sm" />
                            </div>
                            <span className="text-sm text-white/60">{item}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>

                  {/* Right: image */}
                  <div className="rounded-xl overflow-hidden h-56 md:h-auto">
                    <img
                      src={svc.img}
                      alt={svc.title}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
